/**
 * 앱 로그 뷰어 (/adm/app/logs/view — 레이아웃 없는 단독 창) — 로그 파일을 읽어 보여 주고 내려받는다
 * ($j.Pages.Admin.LogViewer / body data-page-name="LogViewer")
 *
 * 파일 주소·등록일·패키지·버전·회원번호는 #page-data.
 */
let fileUrl = '';
let logInfo = {};

export default class LogViewer {
    initialize() {
        const d = JSON.parse(document.getElementById('page-data').textContent);
        fileUrl = d.url;
        logInfo = { regdate: d.regdate, package: d.package, ver: d.ver, mb_no: d.mb_no };
        document.getElementById('btnDownload').addEventListener('click', downloadFile);
        fetch(fileUrl)
            .then(res => res.text())
            .then(text => {
                document.getElementById('loading').style.display = 'none';
                const pre = document.getElementById('logContent');
                pre.style.display = 'block';
                pre.textContent = text;
            })
            .catch(() => {
                document.getElementById('loading').textContent = '로그를 불러올 수 없습니다.';
            });
    }
}

function makeFilename() {
    const d = new Date(logInfo.regdate || '');
    const year = String(d.getFullYear()).slice(2);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${logInfo.mb_no}(${year}-${month}-${day}).txt`;
}

function downloadFile() {
    fetch(fileUrl)
        .then(res => res.blob())
        .then(blob => {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = makeFilename();
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        });
}
